import { render, staticRenderFns } from "./GuidePriceEditor.vue?vue&type=template&id=2ec740e7&scoped=true"
import script from "./GuidePriceEditor.vue?vue&type=script&lang=js"
export * from "./GuidePriceEditor.vue?vue&type=script&lang=js"
import style0 from "./GuidePriceEditor.vue?vue&type=style&index=0&id=2ec740e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec740e7",
  null
  
)

export default component.exports